var map = {
	"./adjuster-productivity.json": 40891,
	"./ai-in-insurance-claims.json": 25987,
	"./ai-in-insurance-underwriting.json": 60448,
	"./claims-analytics.json": 30376,
	"./claims-document-intelligence.json": 33747,
	"./claims-severity-prediction.json": 21387,
	"./claims-triage.json": 85552,
	"./core-platform-integrations.json": 15675,
	"./first-notice-of-loss-fnol.json": 11865,
	"./fraud-detection.json": 12844,
	"./homegrown-self-hosted-integrations.json": 70683,
	"./implementation-roi.json": 32505,
	"./litigation-prediction.json": 76536,
	"./management-benefits.json": 42794,
	"./medical-cost-escalation.json": 43211,
	"./reserve-optimization.json": 52226,
	"./subrogation.json": 83551,
	"./underwriter-productivity.json": 61244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66225;